import { render, staticRenderFns } from "./icon-arrow-left.vue?vue&type=template&id=61c6e3cf&"
import script from "./icon-arrow-left.vue?vue&type=script&lang=js&"
export * from "./icon-arrow-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports